<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
         <transition name="fade">
       <b-card border-variant="info" header-bg-variant="primary" header-text-variant="white">
          <div slot="header">
              <span style="font-size: large;">Manage Own Customer</span>
            </div>
          <div>
          <b-tabs v-model="tabIndex">
              <b-tab title="CUSTOMER DETAILS">
                <customerDetails></customerDetails>
              </b-tab>
              <b-tab title="LOAD CUSTOMER">
                <b-row class="justify-content-center m-1">
                  <b-form-group>
                    <b-form-radio-group
                      id="btn-radios-2"
                      v-model="createCustomerTab"
                      :options="[
                        { text: 'Create New Customers', value: 'newCustomer' },
                        { text: 'Bulk Upload Screen', value: 'uploadCustomer' },
                      ]"
                      buttons
                      class="mr-3"
                      button-variant="outline-primary"
                      size="sm"
                      name="radio-btn-outline"
                    ></b-form-radio-group>
                  </b-form-group>
                </b-row>
                <b-col v-if="createCustomerTab === 'uploadCustomer'">
                  <bulkUpload />
                </b-col>
                <b-col v-if="createCustomerTab === 'newCustomer'">
                  <createCustomer />
                </b-col>
              </b-tab>
              <b-tab title="UPLOAD HISTORY">
               <uploadHistory></uploadHistory>
              </b-tab>
            </b-tabs>
          </div>
        </b-card>
         </transition>
      </b-col>
      </b-row>
  </div>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";
import createCustomer from "@/views/manageOwnCustomer/createCustomer";
import bulkUpload from "@/views/manageOwnCustomer/bulkUpload";
import customerDetails from "@/views/manageOwnCustomer/customerDetails";
import uploadHistory from "@/views/manageOwnCustomer/uploadHistory";
export default {
  name: "Manage-Own-Customer",
  components: {
    ComponentHeader,
    createCustomer,
    bulkUpload,
    customerDetails,
    uploadHistory
  },
  data() {
    return {
        tabIndex: 0,
      createCustomerTab: "newCustomer",
    };
  },
};
</script>
